export default {
  platformName: "教师工作平台",
  updatePswd: "修改密码",
  logout: "退出",
  bindWxTip: "扫码绑定微信号",
  confirmLogout: "确定要退出吗？",
  changePswdSuc: "修改密码成功！",
  selectPlaceholder: "请选择",
  confirm: "确定",
  cancel: "取消",
  mobile: "手机号",
  oldPswd: "旧密码",
  newPswd: "新密码",
  confirmPswd: "确认密码",
  confirmPswdErrTip: "两次输入密码不一致！",
  pswdRule: "字符长度6-20，不能低于6，不高于20",
  phoneRequired: "请输入手机号",
  oldPswdRequired: "请输入旧密码",
  newPswdRequired: "请输入新密码",
  confirmPswdRequired: "请输入确认密码",
  yes: "是",
  no: "否",
  back: "返回",
  user: {
    user: "用户",
    nickName: "用户昵称",
    userId: "用户ID",
    starRating: "星级"
  },
  reply: "回复",
  replyReuired: "请输入回复内容",
  teacher: "老师",
  ok: "知道了",
  optTip: "操作提示",
  submit: "提交",
  save: "保存",
  add: "新增",
  remark: "备注"
};



// WEBPACK FOOTER //
// ./src/i18n/zh-CN/global.js